// src/stone/icons/StoneAgent.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StoneAgent = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M7 24V11h2v13z" }),
      /* @__PURE__ */ jsx("path", { d: "M16 24H8v-2h8z" }),
      /* @__PURE__ */ jsx("path", { d: "M15 24V11h2v13z" }),
      /* @__PURE__ */ jsx("path", { d: "M6.555 10a2 2 0 0 1 1.326-.5h.002l-.003 1v-1h8.24a2 2 0 0 1 1.328.504l3.617 3.216a2 2 0 0 1 .42 2.465L18.89 20.36l-1.749-.971 2.597-4.674L16.12 11.5l.664-.748-.664.747v.001H7.877l.003-.002-.664-.748.661.75-3.612 3.215 2.595 4.674-1.749.97-2.595-4.673a2 2 0 0 1 .42-2.466zM12 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M7.5 4.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0" })
    ]
  }
);
var StoneAgent_default = StoneAgent;

export {
  StoneAgent_default
};
